export default __webpack_public_path__ + "static/media/team9.ba11849c.JPG";